import clsx from "clsx";

function Switch({ checked, onChange, "aria-label": ariaLabel, className }) {
  return (
    <button
      type="button"
      role="switch"
      aria-checked={!!checked}
      aria-label={ariaLabel}
      onClick={() => onChange?.(!checked)}
      className={clsx("relative inline-flex h-5 w-9 shrink-0 items-center rounded-full transition-colors", checked ? "bg-warn" : "bg-border", className)}>
      <span className={clsx("inline-block h-4 w-4 rounded-full bg-surface shadow-card transition-transform", checked ? "translate-x-4" : "translate-x-0.5")} />
    </button>
  );
}

export default Switch;
